export default class ResidentAccountCreateDetails {
  residentId: string;
  firstName: string;
  lastName: string;
  email: string;

  constructor(
    residentId: string,
    firstName: string,
    lastName: string,
    email: string
  ) {
    this.residentId = residentId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
  }
}
